module.exports = __webpack_public_path__ + "img/cons_2.e9d2e38e.jpg";